export default {
  paper: {
    width: 'auto',
  },
};
